import { notification } from 'antd';
const notifyUser = (type, description, message) => {
  notification[type]({ message, description });
};

export default notifyUser;
